<div class="dialog-container">
  <h2 mat-dialog-title>Delete Script</h2>
  
  <mat-dialog-content>
    <div class="dialog-description">
      Are you sure you want to delete the script "<strong>{{ data.scriptTitle }}</strong>"?
    </div>
    <div class="warning-message">
      <mat-icon>warning</mat-icon>
      <span>This action cannot be undone. All versions of this script will be permanently deleted.</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="warn" cdkFocusInitial (click)="onConfirm()">
      Delete Script
    </button>
  </mat-dialog-actions>
</div>





